KMVP.overlays = {

    /**
     * Set or delete CSS definitions for popup.
     * (There are function for that in newer colorbox versions, unfortunatelly this was modified by hybris. Easily updating is complicated.)
     *
     * @param setFixed true if the css definitions has to be set. False if css definitions has to be deleted (needed for other colorboxes i.e. gallery colorbox)
     */
    setColorBoxFixedPosition: function (setFixed) {
        var $colorbox = $('#colorbox');
        var top = $colorbox.position().top;

        if (!$colorbox.length || top === undefined) {
            return;
        }

        // The !important annotation overwrites the inline css definitions of the colorbox.
        if (setFixed === true) {
            if (!$('#colorbox-style').length) {
                $colorbox.before('<style id="colorbox-style">#colorbox{top: ' + top + 'px !important;} #cboxLoadedContent{overflow: hidden !important;}</div>');
            }
        } else {
            $('#colorbox-style').remove();
        }
    },

    initColorboxCloseButtonHandler: function () {
        $('.close-button, .confirmation-button').click(function () {
            var reload = $(this).data('reload');
            $.colorbox.close();
            if (typeof(reload) !== "undefined" && reload !== null && reload !== '') {
                location.reload(true);
            }
        });
    }

};